import './dropdown.css';
import { useState, useRef } from 'react';

export default function Dropdown({ items, onSelect, placeholder, fontSize = "22px", disabledItems = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const timeoutRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (item) => {
    // don't allow selection of disabled items
    if (disabledItems.includes(item)) {
      return;
    }

    setSelectedItem(item);
    setIsOpen(false);
    if (onSelect) onSelect(item);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 500);
  };

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  return (
    <div
      className="dropdown"
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      style={{ fontSize: fontSize }}
    >
      <button
        type="button"
        className="dropdown-toggle"
        onClick={handleToggle}
        style={{ fontSize: fontSize }}
      >
        {selectedItem ? selectedItem : placeholder}
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {items.map((item, index) => {
            const isDisabled = disabledItems.includes(item);
            return (
              <li
                key={index}
                className={`dropdown-item ${isDisabled ? 'disabled' : ''}`}
                onClick={() => handleSelect(item)}
                style={{
                  fontSize: fontSize
                }}
              >
                {item}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}